import axiosInstance from "@/axiosConfig";
import { getApiUrl } from "@/shared/utils/api";
import { buildUrlWithParams } from "@/shared/utils/query-params";
import { SUPPLIERS_ENDPOINTS } from "../configs/endpoints";
import type {
  GetSuppliersParams,
  CreateSupplierPayload,
  UpdateSupplierPayload,
} from "./suppliers.service.types";
import type { Supplier, SupplierResponse } from "../types/suppliers.types";

export class SupplierService {
  static async getSuppliers(params: GetSuppliersParams = {}): Promise<SupplierResponse> {
    const url = getApiUrl(
      buildUrlWithParams(SUPPLIERS_ENDPOINTS.GET_SUPPLIERS, params),
    );

    const response = await axiosInstance.get<SupplierResponse>(url);
    return response.data;
  }

  static async getSupplier(id: string, fields?: string): Promise<{ supplier: Supplier }> {
    const url = getApiUrl(
      buildUrlWithParams(SUPPLIERS_ENDPOINTS.GET_SUPPLIER(id), { fields }),
    );

    const response = await axiosInstance.get<{ supplier: Supplier }>(url);
    return response.data;
  }

  static async createSupplier(payload: CreateSupplierPayload): Promise<{ supplier: Supplier }> {
    const response = await axiosInstance.post<{ supplier: Supplier }>(
      getApiUrl(SUPPLIERS_ENDPOINTS.CREATE_SUPPLIER),
      payload,
    );
    return response.data;
  }

  static async updateSupplier(payload: UpdateSupplierPayload): Promise<{ supplier: Supplier }> {
    const { id, ...updateData } = payload;

    const response = await axiosInstance.put<{ supplier: Supplier }>(
      getApiUrl(SUPPLIERS_ENDPOINTS.UPDATE_SUPPLIER(id)),
      updateData,
    );
    return response.data;
  }

  static async deleteSupplier(id: string): Promise<void> {
    await axiosInstance.delete(getApiUrl(SUPPLIERS_ENDPOINTS.DELETE_SUPPLIER(id)));
  }

  static async deleteSuppliers(ids: string[]): Promise<{ results: string }> {
    const response = await axiosInstance.post<{ results: string }>(
      getApiUrl(SUPPLIERS_ENDPOINTS.DELETE_SUPPLIERS),
      { ids },
    );
    return response.data;
  }
}

export default SupplierService;
